import { useCallback, useEffect, useState } from 'react';

export const DEFAULT_AVATAR_URL =
  'https://secure.gravatar.com/avatar/6cf47358d4a30cb918d996e83b2d67f8718a9e96e68532c9eaf364d0752cb437?s=96&d=mm&r=g';

type AvatarImageProps = {
  src?: string;
  alt: string;
  className?: string;
  title?: string;
  fallbackSrc?: string;
};

const AvatarImage = ({ src, alt, className, title, fallbackSrc = DEFAULT_AVATAR_URL }: AvatarImageProps) => {
  const [imgSrc, setImgSrc] = useState(src || fallbackSrc);

  const handleError = useCallback(() => {
    setImgSrc((prev) => (prev === fallbackSrc ? prev : fallbackSrc));
  }, [fallbackSrc]);

  useEffect(() => {
    setImgSrc(src || fallbackSrc);
  }, [src, fallbackSrc]);

  return <img src={imgSrc} alt={alt} className={className} title={title} onError={handleError} />;
};

export type { AvatarImageProps };
export default AvatarImage;
